<div [ngSwitch]="isModal">
  <div *ngSwitchCase="true">
    <div class="col-12">
      <ng-template [ngTemplateOutlet]="modalContent"></ng-template>
    </div>
  </div>

  <div *ngSwitchDefault>
    <div class="main px-5">
      <div class="row mt-4">
        <div class="col-12 mt-3 py-2 px-5 bg-light-color">
          <div class="col-12 d-flex mt-3 justify-content">
            <div class="d-flex col-10">
              <h3 class="fw-bold text-primary-color my-3">{{ titulo }}</h3>
            </div>
          </div>

          <div class="col-12">
            <ng-template [ngTemplateOutlet]="modalContent"></ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #modalContent>
  <form [formGroup]="dominioForm" id="dominioForm" #formElement (ngSubmit)="submit()">

    <div class="row g-2">
      <ng-container *ngIf="nomeDominio != 'CARGO_TIPO_ENTIDADE'">

        <div class="col-12 form-group">
          <label for="nome" class="form-label required">Nome</label>
          <nz-input-group nzSize="large">
            <input nz-input id="nome" formControlName="nome" placeholder="Nome" />
          </nz-input-group>
        </div>
      </ng-container>

      <ng-container *ngIf="nomeDominio == 'TIPO_CONTATO'">
        <div class="col-12 form-group">
          <label for="telasPermitidas" class="form-label">Exibidos nas telas</label>
          <nz-select formControlName="telasPermitidas" nzShowSearch nzAllowClear nzPlaceHolder="Telas Permitidas"
            nzSize="large" [compareWith]="compareFn" [nzMode]="'multiple'">
            <nz-option [nzValue]="item" [nzLabel]="item.nome" *ngFor="let item of telasPermitidasList" />
          </nz-select>
        </div>
      </ng-container>
      <ng-container *ngIf="nomeDominio == 'GRUPO'">
        <div class="col-12 form-group">
          <label for="tipoGrupo" class="form-label">Tipo do Grupo</label>
          <nz-select formControlName="tipoGrupo" nzShowSearch nzAllowClear nzPlaceHolder="Tipo do Grupo" nzSize="large"
            [compareWith]="compareGrupoFn">
            <nz-option [nzValue]="item.id" [nzLabel]="item.nomeTipoGrupo" *ngFor="let item of tipoGruposList" />
          </nz-select>
        </div>
        <div class="col form-group">
          <label nz-checkbox formControlName="sigiloso">Sigiloso</label>
        </div>
      </ng-container>

      <ng-container *ngIf="nomeDominio == 'CARGO_TIPO_ENTIDADE'">

        <div class="col-12 col-sm-4 form-group">
          <label for="cargoReferencia" class="form-label">Cargo Referência</label>
          <nz-select formControlName="cargoReferencia" nzShowSearch nzAllowClear nzSize="large"
            nzPlaceHolder="Pesquise nome do cargo" [compareWith]="compareFn"
            (ngModelChange)="onCargoReferenciaChange($event)">
            <nz-option [nzValue]="item.id" [nzLabel]="item.nomeCargoReferencia"
              *ngFor="let item of cargoReferenciaList" />
          </nz-select>
        </div>
      </ng-container>
      <ng-container *ngIf="nomeDominio == 'CARGO_TIPO_ENTIDADE'">
        <div class="col-12 col-sm-4 form-group">
          <label for="cargoSubordinado" class="form-label">Cargo Subordinado</label>
          <nz-select formControlName="cargoSubordinado" nzShowSearch nzAllowClear nzSize="large"
            nzPlaceHolder="Pesquise nome do cargo" [compareWith]="compareFn">
            <nz-option [nzValue]="item.id" [nzLabel]="item.nomeCargoReferencia"
              *ngFor="let item of cargoReferenciaList" />
          </nz-select>
        </div>
      </ng-container>
      <ng-container *ngIf="nomeDominio == 'CARGO_TIPO_ENTIDADE'">

        <div class="col-12 col-sm-4 form-group">
          <label for="tipoEntidade" class="form-label">Tipo de Entidade</label>
          <nz-select formControlName="tipoEntidade" nzShowSearch nzAllowClear nzSize="large"
            nzPlaceHolder="Pesquise o tipo da entidade" [compareWith]="compareFn">
            <nz-option [nzValue]="item.id" [nzLabel]="item.nomeTipoEntidade" *ngFor="let item of tipoEntidadeList" />
          </nz-select>
        </div>
        <div class="col-12 col-sm-3 form-group">
          <label for="nivelHierarquico" class="form-label">Nivel Hierárquico</label>
          <nz-input-group nzSize="large">
            <input nz-input id="nivelHierarquico" formControlName="nivelHierarquico"
              placeholder="Digite o Nivel Hierárquico" />
          </nz-input-group>
        </div>
      </ng-container>
      <ng-container *ngIf="nomeDominio == 'CARGO_REFERENCIA'">
        <div class="col-sm-6 form-group my-3">
          <label nz-checkbox formControlName="isSuplente">Suplente</label>
          <!-- <label for="cargo-tipo" class="form-label">Cargo do Tipo</label>
                <nz-radio-group formControlName="isEfetivo" nzName="radiogroup" style="width: 100%">
                  <label class="mt-1" nz-radio [nzValue]="true">Efetivo</label>
                  <label class="mt-1" nz-radio [nzValue]="false">Suplente</label>
                </nz-radio-group> -->
        </div>
      </ng-container>
      <ng-container *ngIf="nomeDominio == 'GRUPO_ECONOMICO' && this.editar">
        <app-lista-transfer [idParams]="idParams"></app-lista-transfer>
      </ng-container>
      <ng-container *ngIf="nomeDominio == 'SUB_TIPO_ENTIDADE'">
        <div class="col-12 col-sm-4 form-group">
          <label for="tipoEntidade" class="form-label">Tipo de Entidade</label>
          <nz-select formControlName="tipoEntidade" nzShowSearch nzAllowClear nzSize="large"
            nzPlaceHolder="Pesquise o tipo da entidade" [compareWith]="compareFn">
            <nz-option [nzValue]="item.id" [nzLabel]="item.nomeTipoEntidade" *ngFor="let item of tipoEntidadeList" />
          </nz-select>
        </div>
        <!-- … seu template … -->

        <ng-container *ngIf="tipoEntidadeOrgao">
          <div class="col-12 col-sm-4 form-group">
            <label for="especificacoes" class="form-label">
              Tipo de Órgão
              <i *ngIf="lockedLabels.length" class="fa fa-info-circle text-primary ms-1" nz-tooltip
                [nzTooltipTitle]="'Os itens com cadeado não podem ser removidos pois possuem cargos vinculados.'">
              </i>
            </label>

            <nz-select formControlName="especificacoes" nzShowSearch nzAllowClear nzSize="large"
              nzPlaceHolder="Pesquise o tipo da especificação" [compareWith]="compareEspecificacaoFn"
              [nzMode]="'multiple'">

              <nz-option *ngFor="let item of especializacaoSubtipoList" [nzValue]="item" [nzLabel]="item.nome"
                [nzDisabled]="item.temCargosVinculados">

                <span>{{ item.nome }}</span>
                <nz-tag *ngIf="item.temCargosVinculados" nzColor="red" nz-tooltip
                  [nzTooltipTitle]="'Não pode ser removido pois possui cargos vinculados'" class="ms-2">
                  🔒 Vinculado
                </nz-tag>
              </nz-option>
            </nz-select>

            <div *ngIf="lockedLabels.length" class="mt-2">
              <nz-alert *ngIf="lockedMessage" [nzMessage]="lockedMessage" nzType="warning" nzShowIcon>
              </nz-alert>

            </div>
          </div>
        </ng-container>

      </ng-container>
    </div>
    <nz-divider></nz-divider>
    <div class="row mb-4">
      <div class="d-flex justify-content-between">
        <div class="col">
          <button nz-button nzType="default" nzSize="large"
            class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="button" (click)="voltar()">
            Voltar
            <span class="fs-3 ms-2 mdi--search"></span>
          </button>
        </div>
        <div class="col d-flex justify-content-end">
          <button nz-button nzType="primary" nzSize="large"
            class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="submit" form="dominioForm">
            {{ inserir ? 'Salvar domínio' : 'Editar domínio' }}
            <span class="fs-3 ms-2 mdi--search"></span>
          </button>
        </div>
      </div>
    </div>
  </form>
</ng-template>